import {watchListHeader, WatchListHeader} from "./wachlist-header/WatchListHeaderComponent";
import {watchList, WatchList} from "./watchlist/WatchListComponent";
import {newWatchlistItem, NewWatchlistItem} from "./new-item/NewWatchlistItemComponent";

export default function() {
    return angular.module("tfApp.watchlist.components", [])
                  .component(WatchListHeader, watchListHeader())
                  .component(WatchList, watchList())
                  .component(NewWatchlistItem, newWatchlistItem())
                  .name;
}
